var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDictionarySearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.338,
    height: 28.774,
    viewBox: "0 0 26.338 28.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12532",
    "data-name": "Group 12532",
    transform: "translate(-328.831 -142.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons8-book",
    d: "M25.955,24.6a.883.883,0,0,0,.883-.883V6.649A2.652,2.652,0,0,0,24.189,4H10.649A2.652,2.652,0,0,0,8,6.649V24.9a2.652,2.652,0,0,0,2.649,2.649H25.955a.883.883,0,0,0,0-1.766H10.649a.884.884,0,0,1-.883-.883V24.6ZM13.593,9.887h7.653a.883.883,0,1,1,0,1.766H13.593a.883.883,0,0,1,0-1.766Z",
    transform: "translate(320.831 138.226)",
    fill: "#401bfa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(339.169 155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14309",
    "data-name": "Path 14309",
    d: "M22.2,20.8A5.376,5.376,0,0,0,23,18a5,5,0,1,0-5,5,5.376,5.376,0,0,0,2.8-.8L22.6,24,24,22.6ZM18,21a3,3,0,1,1,3-3A2.946,2.946,0,0,1,18,21Z",
    transform: "translate(329.169 145)",
    fill: "#401bfa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDictionarySearch);
export default __webpack_public_path__ + "static/media/dictionary_search.de7ae80fdcac5a5e70e3632dcd5e99f4.svg";
export { ForwardRef as ReactComponent };